export interface IJournalPure {
  _id?: any
  participants: IJournalParticipant[]
  dateCreated: Date
  entries: IJournalEntry[]
  lastEntryDate?: Date
  lastInactivityEmail?: Date
  title: string
  description?: string
  ownerId: string
  isLocked: boolean
}
export interface IJournalParticipant {
  memberId: string
  remindNotificationWeekInterval: number // if <1 -> no email reminders
  remindNotificationDayOfWeek: number // 0 -> Sunday, 1 -> Monday, 6 -> Saturday
  entriesNotifications?: boolean // if false -> no instant email about new entries (the in-app notification still goes out)
  lastEntryNotificationEmail?: Date
  lastWeeklyNotificationEmail?: Date
  dateOpened?: Date
}
export interface IJournalParticipantAggregated extends IJournalParticipant {
  journalTitle: string
  ownerId: string
  _id: string
}

// SenderId - member who triggered the action
// ParticipantId - removed/added member (only used if the entry is of type 'participant_add' or 'participant_remove)
export interface IJournalEntry {
  _id?: any
  senderId: string
  content: string
  dateCreated: Date
  entryType: JournalEntryType
  oldTitle?: string
  newTitle?: string
  participantId?: string
}
export enum JournalEntryType {
  SYSTEM_ENTRY = 'system_entry',
  SIMPLE_ENTRY = 'simple_entry',
  TITLE_CHANGE = 'title_change',
  LOCK_STATUS_CHANGE = 'lock_status_change',
  PARTICIPANT_ADD = 'participant_add',
  PARTICIPANT_REMOVE = 'participant_remove',
  LOST_ACCESS = 'lost_access',
}
export enum JournalParticipantAddOptions {
  BUDDIES = 'buddies',
  LEADS = 'leads',
  ADMINS = 'admins',
}

export interface IJournalPreferences {
  entriesNotifications: boolean
  remindNotificationWeekInterval: number
  remindNotificationDayOfWeek: number
}

export interface ICreateJournalInput extends IJournalPreferences {
  title: string
  description?: string
  isLocked: boolean
}

export interface IJournalConfig {
  title: string
  description?: string
  participantsToAdd: JournalParticipantAddOptions[]
  memberPreference: IJournalPreferences
  participantPreference: IJournalPreferences
}
